import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 's-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss'],
})
export class SCardHeaderComponent implements OnInit {
  constructor() {}

  @Input() title?: string | undefined;

  ngOnInit(): void {}
}
